export const getFilesByPrefix = (images: Record<string, string>, prefix: string) => {
    return Object.entries(images)
        .filter(([key]) => key.startsWith(prefix))
        .map(([key, url]) => {
            const index = Number(key.split(prefix)[1]);

            return {
                key,
                url,
                index,
            };
        })
        .sort((a, b) => a.index - b.index)
        .map((a) => a.url);
};